import OnboardingStep, { OnboardingStepOrder } from "./OnboardingStep"

function nextOnboardingStepExists(step: OnboardingStep): boolean {
    const index = OnboardingStepOrder.indexOf(step)
    return index !== OnboardingStepOrder.length - 1
}

function previousOnboardingStepExists(step: OnboardingStep): boolean {
    const index = OnboardingStepOrder.indexOf(step)
    return index !== 0
}

export { nextOnboardingStepExists, previousOnboardingStepExists }
